
import * as appsettings from "../appsettings";
import * as dialog      from "../dialog";
import * as form        from "../form";
import * as grid        from "../grid";

function removeMessageGroup(preComMsgGroupId: number): void {

    $.ajax({
        type: "POST",
        data:
        {
            preComMsgGroupId: preComMsgGroupId,
        },
        url: appsettings.getUrl("PreComMsgGroup/Delete"),
        success: function () {
            $("#PreComMsgGroupGrid").data("kendoGrid").dataSource.read();
            $("#DivMsgGrpUsers").html('');
        }
    });

}


export function initialize(): void {

    $(document)        
        .off("click.overviewAddCrew", "#PreComMsgGroupGrid .k-grid-add")
        .on("click.overviewAddCrew", "#PreComMsgGroupGrid .k-grid-add", function (e: JQuery.Event): void {

        // Prevent default behaviour
        e.preventDefault();

        addItem();
    });
    grid.loadGridOptions("PreComMsgGroupGrid");
}

/* Why is this ? Edit and adding are actions where the user needs to be redirected to. 
 * See group configuration. Set viewmode, Set navigation url to form / page for add or edit action. breadcrumb ....
 * use the same format for consistency */
export function addItem(): void {
    $("#DivMsgGrpUsers").load(appsettings.getUrl("PreComMsgGroup/Add"));
}

export function showItem(e: JQuery.Event & { currentTarget: HTMLElement }): void {
    var selectedItem = this.dataItem($(e.currentTarget).closest("tr")) as PreComMsgGroupVM;
    $("#DivMsgGrpUsers").load(appsettings.getUrl("PreComMsgGroup/Show?preComMsgGroupId=" + selectedItem.PreComMsgGroupID));
}

export function editItem(e: JQuery.Event & { currentTarget: HTMLElement }): void {
    var selectedItem = this.dataItem($(e.currentTarget).closest("tr")) as PreComMsgGroupVM;
    $("#DivMsgGrpUsers").load(appsettings.getUrl("PreComMsgGroup/Edit?preComMsgGroupId=" + selectedItem.PreComMsgGroupID));
}

export function deleteItem(e: JQuery.Event & { currentTarget: HTMLElement }): void {

    const event = e;
    const data = this;

    function callbackYes(event: JQuery.Event & { currentTarget: HTMLElement }, data: kendo.ui.Grid): void {
        // Prevent default behaviour 
        event.preventDefault();

        const dataItem = data.dataItem($(event.currentTarget).closest("tr")) as PreComMsgGroupVM;
        // Post Data
        removeMessageGroup(dataItem.PreComMsgGroupID)
    }

    function callingCallback(): void {
        callbackYes(event, data);
    }

    dialog.createDialog(callingCallback, function () { });
}

export function onCancelButtonClicked(): void {
    $("#DivMsgGrpUsers").html('');
}

export function onSaveButtonClicked(preComMessageGroupId: number): void {
    var label = $("#Label").data("kendoTextBox").value();
    var list = JSON.stringify($("#PreComMsg_CplSelected").data("kendoListBox").dataItems());

    $.ajax({
        type: "POST",
        data:
        {
            preComMsgGroupId: preComMessageGroupId,
            label: label,
            assigned: list
        },
        url: appsettings.getUrl("PreComMsgGroup/Submit"),
        success: function (responseData: responseModel | undefined | null) {

            var grid = $("#PreComMsgGroupGrid").data("kendoGrid");
            if (grid != null && grid != undefined) {
                grid.dataSource.read();
            }

            $("#DivMsgGrpUsers").load(appsettings.getUrl("PreComMsgGroup/Edit?preComMsgGroupId=" + preComMessageGroupId), null, function () {
                if (responseData != null && responseData != undefined) {
                    form.showServerResponse("LRShowResponse", responseData, function () { });
                }
            });
        }
    });
}
